import React, { Fragment, Component } from 'react';
import { 
    Typography, Tooltip, Row, Col, Button, Image, Modal, Form, Input, 
    Radio, Select, Card, Divider, Spin, Upload, Steps, Carousel
} from 'antd';
import InputMask from 'react-input-mask';
import { ALLOWED_EXTENSION, Reimburse, Deduction, Countries, CURRENCY } from "../constants";
import moment from 'moment';
import { validateQoute, uploadIds, makePayment, makePaymentViaTamara, calculateQuote, getUserDetailsById, sendLeadEmail, updateLead } from '../api/pets-api';
import { notifications, upperCase, applyDiscountVat } from '../helpers/utilities';
import imageCompression from 'browser-image-compression';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import ReactFlagsSelect from 'react-flags-select';
import { UploadOutlined } from '@ant-design/icons';
import { PasswordInput } from 'antd-password-input-strength';
import Sidebar from '../components/common/sidebar';
import MainLayout from '../layouts/mainLayout';
import tamaralogo from '../assets/images/tamara-en.png';

const { Paragraph, Title } = Typography;
const { Option } = Select;
const { Step } = Steps;

// Initialize date variables for coverage dates
let date = new Date();
date.setDate(date.getDate() + 1);
let longMonth = date.toLocaleString('en-us', { month: 'long' });

let acc = new Date();
acc.setDate(date.getDate() + 6);
let accMonth = acc.toLocaleString('en-us', { month: 'long' });

let ill = new Date();
ill.setDate(date.getDate() + 14);
let illMonth = ill.toLocaleString('en-us', { month: 'long' });

let kne = new Date();
kne.setMonth(date.getMonth() + 6);
let kneMonth = kne.toLocaleString('en-us', { month: 'long' });

const staticAddress = {
    latitude: 25.276987, 
    longitude: 55.296249, 
    addressesLine1: 'Dubai UAE', 
    city: 'Dubai', 
    country: 'UAE'
};

class UserInformation extends Component {
    state = {
        visible: false,
        spinning: false,
        tip: 'Processing your request...',
        idUploadFlag: true,
        total: 0,
        address: [],
        lat: '',
        lng: '',
        nationality: '',
        appartment: '',
        street: '',
        city: '',
        visibleSP: false,
        petsWithPlans: [],
        frontUploaded: false,
        backUploaded: false,
        runningUserObject: {},
        pricingDetails: {},
        selectedPaymentMethod: 'ot',
        selectedInstallments: 4,
        tamaraPremiumTotal: 0,
        tamaraPolicyFee: 0,
        tamaraTotal: 0,
        tamaraInstallmentValue: 0,
        policyFee: 50,
        enableTamara: true,
        eidFrontFilename: '',
        eidBackFilename: '',
        isPolicyExpired: false,
        preQoute: null,
        dataLoaded: false,
        userAlreadyExists: false,
        userId: null,
        existingUserData: null,
    };
    
    formRef = React.createRef();
    addressFormRef = React.createRef();
    secPetParentFormRef = React.createRef();

    componentDidMount() {
        window.scrollTo(0, 0);
        
        // Get location data
        navigator.geolocation.getCurrentPosition((position) => {
            this.setState({ lat: position.coords.latitude, lng: position.coords.longitude });
        });
        
        // Get saved quote data
        const storedData = localStorage.getItem('osloQuoteData');
        if (storedData) {
            const quoteData = JSON.parse(storedData);
            this.setState({ 
                preQoute: quoteData,
                dataLoaded: true
            });
            this.trackConversion();
            this.fetchQuoteCalculation(quoteData);
        }
    }

    trackConversion = () => {
        try {
            if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
                // Fire the Google Ads conversion event
                window.gtag('event', 'conversion', {
                    'send_to': 'AW-11487089889/VahXCIKvt_saEOGpvOUq'
                });
                
                console.log('Google Ads conversion event fired on quotation page');
            }
        } catch (error) {
            console.error('Error tracking conversion:', error);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // Populate email when form is ready, preQoute is loaded, and user doesn't already exist
        if (!prevState.dataLoaded && 
            this.state.dataLoaded && 
            this.state.preQoute?.email && 
            !this.state.userAlreadyExists && 
            this.formRef.current) {
            setTimeout(() => {
                this.formRef.current.setFieldsValue({
                    email_address: this.state.preQoute.email
                });
            }, 100);
        }
    }

    fetchUserData = async (userId) => {
        try {
            console.log('Fetching user data for userId:', userId);
            const response = await getUserDetailsById(userId);
            
            if (response && response.status === 200) {
                console.log('User data fetched successfully:', response.data.result);
                this.setState({ 
                    existingUserData: response.data.result,
                    userId: response.data.result.id
                });
                return response.data.result;
            } else {
                console.error('Failed to fetch user data');
                notifications('error', 'Failed to load user information');
                return null;
            }
        } catch (error) {
            console.error('Error fetching user data:', error);
            notifications('error', 'Error loading user information');
            return null;
        }
    };

    fetchQuoteCalculation = async (quoteData) => {
        try {
            this.setState({ spinning: true, tip: 'Calculating your quote...' });
            
            const response = await calculateQuote(quoteData);
            
            if (response && response.status === 200) {
                const result = response.data.result;
                
                // Map API response to state
                const petsWithPlans = result.petQuotes.map(petQuote => {
                    const petFromStorage = quoteData.pets.find(p => 
                        p.name === petQuote.petName && 
                        p.petTypeId === petQuote.petTypeId
                    );
                    
                    return {
                        name: petQuote.petName,
                        petTypeId: petQuote.petTypeId,
                        breedId: petQuote.breedId,
                        dob: petQuote.dob,
                        gender: petQuote.gender,
                        planId: petFromStorage?.planId || petQuote.planId,
                        planName: petQuote.planName,
                        planBenefits: petQuote.planBenefits,
                        basePrice: petQuote.basePrice,
                        discount: petQuote.discount,
                        discountAmount: petQuote.discountAmount.toFixed(2),
                        discountType: petQuote.discountType,
                        priceAfterDiscount: petQuote.priceAfterDiscount,
                        vatAmount: petQuote.vatAmount,
                        vatRate: petQuote.vatRate,
                        planVal: petQuote.basePrice.toFixed(2),
                        policyValue: petQuote.policyFee.toFixed(2),
                        vat: petQuote.vatAmount.toFixed(2),
                        total: petQuote.totalPrice.toFixed(2),
                        // Keep the existing properties needed for UI
                        reimbursement: petFromStorage?.reimbursement || 80,
                        deductible: petFromStorage?.deductible || 250,
                        policyEffectiveDate: new Date(petQuote.policyEffectiveDate),
                        accidentCoverEffectiveDate: new Date(petQuote.accidentCoverEffectiveDate),
                        illnessCoverEffectiveDate: new Date(petQuote.illnessCoverEffectiveDate),
                        kneeCoverEffectiveDate: new Date(petQuote.kneeCoverEffectiveDate),
                    };
                });
                
                this.setState({
                    petsWithPlans,
                    total: result.totalPrice,
                    tamaraPremiumTotal: result.totalTamaraPremium,
                    tamaraPolicyFee: result.totalTamaraPolicyFee,
                    userAlreadyExists: result.userExists,
                    userId: result.userId,
                    spinning: false,
                    policyFee: result.totalPolicyFee,
                    currency: result.currency || 'AED',
                    currencySymbol: result.currencySymbol || 'د.إ'
                });
                
                // Fetch user data if user already exists
                if (result.userExists && result.userId) {
                    await this.fetchUserData(result.userId);
                }
                
                // Calculate Tamara prices
                this.calculateTamaraPrices();
            } else {
                this.setState({ 
                    spinning: false,
                    errorMessage: 'Failed to calculate quote. Please try again.'
                });
                notifications('error', 'Failed to calculate quote');
            }
        } catch (error) {
            console.error('Error calculating quote:', error);
            this.setState({ 
                spinning: false,
                errorMessage: 'An error occurred while calculating your quote.'
            });
            notifications('error', 'Failed to connect to server');
        }
    };

    calculateTamaraPrices = () => {
        // Similar to calculatePrices but for Tamara payment option
        if (!this.state.tamaraPremiumTotal) return;
        
        const sum = (this.state.tamaraPremiumTotal + this.state.tamaraPolicyFee) * 1.05; // Add 5% for Tamara payment
        const installmentValue = Number(parseFloat(sum / this.state.selectedInstallments).toFixed(2));
        
        this.setState({ 
            tamaraTotal: sum, 
            tamaraInstallmentValue: installmentValue 
        });
    };

    saveQuote = async () => {
        this.setState({ spinning: true, tip: 'Saving your quote...' });

        const leadId = localStorage.getItem('lead');

        let obj = {
                    id:leadId,
                    email:this.state.preQoute?.email,
                    planObj:this.state.preQoute,
                    userObj:null
        }
        let res = await updateLead(obj);
        if (res.data.errors) {
            res.data.errors.map(error => {
                notifications('Error', error.msg, 'error');

            })
            this.setState({ spinning: false, tip: '' });
        } else {
            //notifications('Success', 'Your information saved in the system. You may receive an email with link to your quote', 'success');

            let usrObj = {
                user:{
                    email:obj.email,
                    leadId:res.data.result.id
                }
            }
    
            let resEmail = await sendLeadEmail(usrObj);
            if (resEmail.data.errors) {
                resEmail.data.errors.map(error => {
                    notifications('Error', error.msg, 'error');
                })
                this.setState({ spinning: false, tip: '' });
            } else {
                notifications('Success', 'Please check your inbox for email link for saved quotation.', 'success');
                this.setState({ spinning: false, tip: '' });
            }
        }
    }
    // -------------------- Modal Methods --------------------
    
    showModal = () => {
        this.setState({ visible: true });
    };
    
    showModalSP = () => {
        this.setState({ visibleSP: true });
    };
    
    handleCancel = () => {
        this.setState({ visible: false });
    };
    
    handleCancelSP = () => {
        this.setState({ visibleSP: false });
    };
    
    // -------------------- Form Methods --------------------
    
    formSetLocation = (values) => {
        this.formRef.current.setFieldsValue({
            add_address: values.city,
        });
        
        this.setState({ 
            visible: false, 
            appartment: values.appartment, 
            street: values.street, 
            city: values.city, 
            address: [staticAddress] 
        }, () => {
            notifications('success', 'Address Added Successfully', 'Location', 2);
        });
    };
    
    formSetSecPetParent = (values) => {
        this.setState({ visibleSP: false }, () => {
            notifications('success', 'Secondary Pet Parent Added Successfully', 'Location', 2);
        });
    };
    
    // -------------------- Upload Methods --------------------
    
    uploadId = async (options, side) => {
        const { onSuccess, onError, file } = options;
    
        try {
            // Image compression options
            const compressionOptions = {
                maxSizeMB: 1.5,
                useWebWorker: true,
            };
    
            // Compress the file
            const compressedFile = await imageCompression(file, compressionOptions);
    
            // Extract the file extension
            const ext = compressedFile.name.split('.').pop();
            
            // Generate the new file name based on emiratesId and side
            const name = `${this.formRef.current.getFieldValue('emiratesId')}-${side}.${ext}`;
            const newFile = new File([compressedFile], name);
    
            // Create FormData object
            const fmData = new FormData();
            const config = {
                headers: { "content-type": "multipart/form-data" },
            };
    
            // Append file and side to FormData
            fmData.append("image", newFile);
            fmData.append("side", side);
    
            // Set loading state
            this.setState({ spinning: true, tip: "Uploading Emirates ID..." });
    
            // Make the API call to upload the file
            const res = await uploadIds(fmData, config);
    
            // Reset loading state
            this.setState({ spinning: false });
    
            if (res.data.status === "ok") {
                onSuccess("Ok");
                notifications('success', res.data.message, 'Uploads', 3);
    
                // Update the state based on the side
                if (side === 'front') {
                    this.setState({ frontUploaded: true, eidFrontFilename: res.data.data.fileUrl });
                } else {
                    this.setState({ backUploaded: true, eidBackFilename: res.data.data.fileUrl });
                }
            } else {
                onError("Error");
                notifications('error', res.data.message, 'Uploads', 3);
            }
        } catch (err) {
            console.error("Error: ", err);
            onError({ err });
            this.setState({ spinning: false });
            notifications('error', 'Please check the selected file. Only images are accepted.', 'Uploads', 3);
        }
    };
    
    idChange = (e) => {
        const idCount = e.target.value.replace(/[^0-9]/g, "").length;
        this.setState({ idUploadFlag: idCount !== 15 });
    };
    
    idUploadClick = () => {
        if (this.state.idUploadFlag) {
            notifications('error', 'Provide Emirates ID first', 'Id Required');
        }
    };

    // -------------------- Form Submission --------------------
    
    infoValueChanged = (changedValues, allValues) => {
        const usrObj = {
            firstName: allValues.first_name,
            lastName: allValues.last_name,
            email: allValues.email_address,
            nationality: allValues.nationality ? Countries[allValues.nationality] : '',
            emiratesId: allValues.emiratesId,
            phoneNo: allValues.phone,
            addresses: [{ 
                ...this.state.address[0], 
                apartmentNumber: this.state.appartment, 
                city: this.state.city, 
                street: this.state.street 
            }]
        };
        
        this.setState({ runningUserObject: usrObj });
    };
    
    infoSubmit = async (values) => {
        // Validate all fields before submitting
        if(!this.state.userAlreadyExists){
            try {
                await this.formRef.current.validateFields();
            } catch (error) {
                console.log('Validation failed:', error);
                notifications('error', 'Please correct the form errors before submitting');
                return;
            }
            
            if (!this.state.frontUploaded || !this.state.backUploaded) {
                notifications('error', 'Please upload your Emirates ID images');
                return;
            }
        }
        
        
        // Prepare pets data
        const pets = this.state.preQoute.pets.map(pet => ({
            name: pet.name,
            petTypeId: pet.petTypeId,
            breedId: pet.breedId,
            dob: moment(pet.dob).format('YYYY/MM/DD'),
            gender: pet.gender
        }));
        
        let usrObj = {};

        if(!this.state.userAlreadyExists){
            usrObj = {
                firstName: values.first_name,
                lastName: values.last_name,
                email: values.email_address,
                password: values.password,
                nationality: Countries[values.nationality],
                emiratesId: values.emiratesId,
                phoneNo: values.phone,
                addresses: [{ 
                    ...this.state.address[0], 
                    apartmentNumber: this.state.appartment, 
                    city: this.state.city, 
                    street: this.state.street 
                }],
                eidFront: this.state.eidFrontFilename,
                eidBack: this.state.eidBackFilename
            };
        }
        else{
            // Use existing user data from API
            const existingUser = this.state.existingUserData;
            if (existingUser) {
                usrObj = {
                    id: existingUser.id,
                    firstName: existingUser.firstName,
                    lastName: existingUser.lastName,
                    email: existingUser.email,
                    emiratesId: existingUser.emiratesId,
                    nationality: existingUser.nationality,
                    phoneNo: existingUser.phoneNo,
                    addresses: existingUser.addresses || [],
                    eidFront: existingUser.eidFront,
                    eidBack: existingUser.eidBack,
                    iban: existingUser.iban,
                    bankName: existingUser.bankName,
                    swiftCode: existingUser.swiftCode,
                    bankAddress: existingUser.bankAddress,
                    userRole: existingUser.userRole,
                    image: existingUser.image,
                    createdAt: existingUser.createdAt
                };
            } else {
                // Fallback if existing user data is not available
                usrObj = {
                    id: this.state.userId,
                };
            }
        }

        // Prepare user data
        

        var retrievedObject = localStorage.getItem('quoteObj');
        var quoteObj = JSON.parse(retrievedObject);

        // Create final object to submit
        const finalObj = {
            user: usrObj,
            pets: pets,
            total: this.state.total,
            effectiveDate: date
        };
        
        // Save data to localStorage
        localStorage.setItem('userData', JSON.stringify(finalObj));
        
        // Show spinner while processing
        this.setState({ spinning: true, tip: "Processing your request..." });
        
        try {
            if(!this.state.userAlreadyExists){
                const res = await validateQoute(finalObj);
            
                if (res.data.errors) {
                    res.data.errors.forEach(error => {
                        notifications('error', error.msg);
                    });
                    this.setState({ spinning: false });
                }
            }
            // Process payment based on selected method
            if (this.state.selectedPaymentMethod === 'ot') {
                await this.processOneTimePayment(this.state.total, finalObj);
            } else {
                await this.processTamaraPayment(
                    this.state.tamaraTotal, 
                    this.state.selectedInstallments,
                    finalObj
                );
            }
            
            // Navigate to next page or handle success
            // window.location.href = '/quote-confirmation';
        } catch (error) {
            console.error('Error submitting form:', error);
            this.setState({ spinning: false });
            notifications('error', 'There was an error processing your request. Please try again.');
        }
    };

    // -------------------- Payment Methods --------------------
    
    processOneTimePayment = async (total, paymentInfo) => {
        const sum = total * 100;
        
        const payObj = {
            amount: sum,
            userAndPets: paymentInfo,
            petsWithPlans: this.state.preQoute
        };
        
        const payRes = await makePayment(payObj);
        
        if (payRes.data.result) {
            window.location.replace(payRes.data.result);
        } else {
            notifications('error', 'Some issue encountered while processing your request');
            this.setState({ spinning: false });
        }
    };
    
    processTamaraPayment = async (total, installmentCount, paymentInfo) => {

        // Ensure total is a numeric value with exactly 2 decimal places
        const formattedTotal = Number(parseFloat(total).toFixed(2));

        const payObj = {
            amount: formattedTotal,
            installmentCount: installmentCount,
            userAndPets: paymentInfo,
            petsWithPlans: this.state.preQoute
        };
        
        const payRes = await makePaymentViaTamara(payObj);
        
        if (payRes.data.result.checkout_url) {
            window.location.replace(payRes.data.result.checkout_url);
        } else {
            notifications('error', 'Some issue encountered while processing your request');
            this.setState({ spinning: false });
        }
    };
    
    onPaymentMethodChange = (method) => {
        if (method === 'mi' && this.state.tamaraTotal > 20000) {
            notifications('error', 'Total is more than AED 20000, Tamara is unable to process');
        } else {
            this.setState({ selectedPaymentMethod: method });
        }
    };
    
    // -------------------- Helper Methods --------------------
    
    setNatinality = (code) => {
        this.setState({ nationality: code });
        this.formRef.current.setFieldsValue({ nationality: code });
    };
    
    findCountry = (value) => {
        for (let key in Countries) {
            if (Countries[key] === value) return key;
        }
        return false;
    };
    
    // -------------------- Render Method --------------------
    
    render() {
        const { spinning, tip, petsWithPlans, dataLoaded, nationality } = this.state;
        
        if (!dataLoaded) {
            return (
                <Spin spinning={true} tip="Loading your information...">
                    <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        Loading...
                    </div>
                </Spin>
            );
        }
        
        return (
            <Fragment>
                <MainLayout>
                    <div className="container">
                        <Row gutter={[15, 15]}>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <div className="get-quote-wrp step-wizard-wrp full-width mt-5 mb-5">
                                    {/* Steps Indicator */}
                                    <Row gutter={15} justify="center" className="mb-5">
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <Steps className="custom-wizard-steps mt-5" size="large" current={1}>
                                                <Step key={1} title={'QUOTE'} />
                                                <Step key={2} title={'YOUR INFO'} />
                                                <Step key={3} title={'WELCOME'} />
                                            </Steps>
                                        </Col>
                                    </Row>
                                    
                                    <Row gutter={15}>
                                        <Col xl={16} lg={16} md={24} sm={24} xs={24}>
                                            <Spin spinning={spinning} tip={tip} size="large">
                                                <Form
                                                    name="basic"
                                                    size={"large"}
                                                    className="customise-form"
                                                    onFinish={this.infoSubmit}
                                                    onValuesChange={this.infoValueChanged}
                                                    ref={this.formRef}
                                                    key={this.state.preQoute?.email || 'no-email'}
                                                    initialValues={{
                                                        email_address: this.state.preQoute?.email || ''
                                                    }}
                                                >
                                                    <div>
                                                        <div className="section-gray">
                                                            <div className="section-heading">Your info</div>
                                                        </div>
                                                        {!this.state.userAlreadyExists && 

                                                        <>
                                                        


                                                        <div className="section-gray">
                                                            <Row gutter={15}>
                                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                    <Title className="text-light-green" level={2}>Primary pet parent</Title>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                    <Form.Item
                                                                        name="first_name"
                                                                        validateTrigger="onBlur"
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message: 'Please input your first name',
                                                                            },
                                                                        ]}
                                                                    >
                                                                        <Input placeholder={"First Name *"} />
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                    <Form.Item
                                                                        name="last_name"
                                                                        validateTrigger="onBlur"
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message: 'Please input your last name',
                                                                            },
                                                                        ]}
                                                                    >
                                                                        <Input placeholder={"Last Name *"} />
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                    <Form.Item
                                                                        name="add_address"
                                                                        validateTrigger="onBlur"
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message: 'Please input your address',
                                                                            },
                                                                        ]}
                                                                    >
                                                                        <Input 
                                                                            readOnly={true} 
                                                                            placeholder={"Add Address"} 
                                                                            onClick={this.showModal} 
                                                                            prefix={<i className="fa fa-plus-circle text-light-green"></i>} 
                                                                        />
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                    <Form.Item
                                                                        name="phone"
                                                                        size={"large"}
                                                                        validateTrigger="onBlur"
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message: 'Please input your phone number',
                                                                            },
                                                                        ]}
                                                                    >
                                                                        <PhoneInput
                                                                            inputStyle={{ width: '100%', height: '53px' }}
                                                                            country={'ae'}
                                                                            placeholder={"Add Phone number"}
                                                                        />
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                    <Form.Item
                                                                        name="emiratesId"
                                                                        validateTrigger="onBlur"
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message: 'Please enter correct emirates ID',
                                                                                pattern: new RegExp(/^\d{3}-\d{4}-\d{7}-\d{1}$/)
                                                                            },
                                                                        ]}
                                                                    >
                                                                        <InputMask
                                                                            mask="999-9999-9999999-9"
                                                                            placeholder="Add Emirates ID"
                                                                            onChange={this.idChange}
                                                                            style={{width: '100%'}}
                                                                        >
                                                                            {(inputProps) => <Input {...inputProps} />}
                                                                        </InputMask>
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                    <Form.Item
                                                                        name="nationality"
                                                                        validateTrigger="onBlur"
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message: 'Please select your nationality',
                                                                            },
                                                                        ]}
                                                                        value={nationality}
                                                                        initialValue={nationality}
                                                                    >
                                                                        <ReactFlagsSelect
                                                                            className="flag-select"
                                                                            selected={nationality}
                                                                            onSelect={this.setNatinality}
                                                                            placeholder={"Select Nationality"} 
                                                                            searchable={true}
                                                                        />
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={24} lg={24} xl={24} className="upload-id-card">
                                                                    <Row gutter={15}>
                                                                        <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                                                                            <Form.Item
                                                                                name="frontID"
                                                                                validateTrigger="onBlur"
                                                                                rules={[
                                                                                    {
                                                                                        required: true,
                                                                                        message: 'Please upload emirates Id (front)',
                                                                                    },
                                                                                ]}
                                                                                onClick={this.idUploadClick}
                                                                            >
                                                                                <Upload
                                                                                    maxCount={1}
                                                                                    accept={ALLOWED_EXTENSION}
                                                                                    customRequest={(op) => this.uploadId(op, 'front')}
                                                                                    disabled={this.state.idUploadFlag}
                                                                                    wrapperCol={{ sm: 24 }}
                                                                                    style={{width: '100% !important'}}
                                                                                >
                                                                                    <Button icon={<UploadOutlined />}>Front Side of Emirates ID</Button>
                                                                                </Upload>
                                                                            </Form.Item>
                                                                        </Col>
                                                                        <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                                                                            <Form.Item
                                                                                name="backID"
                                                                                validateTrigger="onBlur"
                                                                                rules={[
                                                                                    {
                                                                                        required: true,
                                                                                        message: 'Please upload emirates Id (back)',
                                                                                    },
                                                                                ]}
                                                                                onClick={this.idUploadClick}
                                                                            >
                                                                                <Upload
                                                                                    maxCount={1}
                                                                                    accept={ALLOWED_EXTENSION}
                                                                                    customRequest={(op) => this.uploadId(op, 'back')}
                                                                                    disabled={this.state.idUploadFlag}
                                                                                    wrapperCol={{ sm: 24 }}
                                                                                    style={{width: '100% !important'}}
                                                                                >
                                                                                    <Button icon={<UploadOutlined />}>Back Side of Emirates ID</Button>
                                                                                </Upload>
                                                                            </Form.Item>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                    <div className="add-pet text-center mt-4 position-static">
                                                                        <Button type={"link"} onClick={this.showModalSP} className="text-light-green">
                                                                            <div className="icon"><i className="fa fa-plus-circle"></i></div>
                                                                            Add secondary pet parent
                                                                        </Button>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                        <div className="section-gray">
                                                            <Row gutter={15}>
                                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                    <Title className="text-light-green" level={2}>Pet Cloud Login</Title>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                    <Form.Item
                                                                        name="email_address"
                                                                        validateTrigger="onBlur"
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message: 'Please input your email! *',
                                                                            },
                                                                            {
                                                                                type: 'email',
                                                                                message: 'Please input correct email! ',
                                                                            },
                                                                            {
                                                                                validator: (_, value) => {
                                                                                    if (value && value.trim() !== value) {
                                                                                        return Promise.reject(new Error('Email should not have leading or trailing spaces!'));
                                                                                    }
                                                                                    if (value && /[A-Z]/.test(value)) {
                                                                                        return Promise.reject(new Error('Email should be in lowercase!'));
                                                                                    }
                                                                                    return Promise.resolve();
                                                                                },
                                                                            },
                                                                            
                                                                        ]}
                                                                    >
                                                                        <Input 
                                                                            placeholder={"Email Address*"} 
                                                                            readOnly={true}
                                                                            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === " " || e.getModifierState("CapsLock")) {
                                                                                    e.preventDefault(); // Prevent spaces and Caps Lock
                                                                                }
                                                                            }}
                                                                            onKeyUp={(e) => {
                                                                                if (e.key === " " || e.getModifierState("CapsLock")) {
                                                                                    e.preventDefault(); // Prevent spaces and Caps Lock
                                                                                }
                                                                            }}
                                                                            onKeyPress={(e) => {
                                                                                if (e.key === " " || e.getModifierState("CapsLock")) {
                                                                                    e.preventDefault(); // Prevent spaces and Caps Lock
                                                                                }
                                                                            }}
                                                                        />
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                    <Form.Item
                                                                        name="confirm_email_address"
                                                                        dependencies={['email_address']}
                                                                        validateTrigger="onBlur"
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message: 'Please confirm your email address',
                                                                            },
                                                                            ({ getFieldValue }) => ({
                                                                                validator(_, value) {
                                                                                    if (!value || getFieldValue('email_address') === value) {
                                                                                        return Promise.resolve();
                                                                                    }
                                                                                    return Promise.reject(new Error('Entered emails do not match'));
                                                                                },
                                                                            }),
                                                                        ]}
                                                                    >
                                                                        <Input placeholder={"Confirm Email Address*"} />
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                    <Form.Item
                                                                        name="password"
                                                                        validateTrigger="onBlur"
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message: 'Please input your password',
                                                                            },
                                                                            {
                                                                                pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
                                                                                message: 'Password must be at least 8 characters long, contain letters, numbers, and 1 special character.',
                                                                            },
                                                                        ]}
                                                                    >
                                                                        <PasswordInput 
                                                                            style={{ lineHeight: '10px' }} 
                                                                            placeholder={"Password*"} 
                                                                        />
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                    <Form.Item
                                                                        name="confirm_password"
                                                                        dependencies={['password']}
                                                                        validateTrigger="onBlur"
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message: 'Please confirm your password',
                                                                            },
                                                                            ({ getFieldValue }) => ({
                                                                                validator(_, value) {
                                                                                    if (!value || getFieldValue('password') === value) {
                                                                                        return Promise.resolve();
                                                                                    }
                                                                                    return Promise.reject(new Error('Passwords do not match!'));
                                                                                },
                                                                            }),
                                                                        ]}
                                                                    >
                                                                        <Input type="password" placeholder={"Confirm Password*"} />
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                        </div>

                                                        </>
                                                        }

                                                        {/* Show message when user already exists */}
                                                        {this.state.userAlreadyExists && this.state.existingUserData && (
                                                            <div className="section-gray">
                                                                <div className="existing-user-message" style={{ 
                                                                    padding: '20px', 
                                                                    backgroundColor: '#f9f9f9', 
                                                                    border: '1px solid #e0e0e0',
                                                                    borderRadius: '6px',
                                                                    marginBottom: '20px'
                                                                }}>
                                                                    <Row gutter={15} align="middle">
                                                                        <Col span={2}>
                                                                            <i className="fa fa-info-circle" style={{ color: '#999', fontSize: '20px' }}></i>
                                                                        </Col>
                                                                        <Col span={22}>
                                                                            <div>
                                                                                <h3 style={{ margin: 0, color: 'rgba(0, 0, 0, 0.7)' }}>Welcome back, {this.state.existingUserData.firstName}!</h3>
                                                                                <p style={{ margin: '5px 0 0 0', color: '#666' }}>
                                                                                    We found your existing account with email: <strong>{this.state.existingUserData.email}</strong>
                                                                                    <br />
                                                                                    You can proceed directly to payment.
                                                                                </p>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                    
                                                    <div className="section-gray pet-summary">
                                                        <Row gutter={15}>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                <Title className="text-light-green" level={2}>Payment Summary</Title>
                                                            </Col>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12} justify="end">
                                                                {/* Payment type selection could go here */}
                                                            </Col>
                                                            
                                                            {petsWithPlans.map((pp, objIndex) => (
                                                                <Col key={objIndex} xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                    <Row gutter={15} align="middle">
                                                                        <Col xs={24} sm={16} md={16} lg={16} xl={16}>
                                                                            <div className="pet-name">
                                                                                <Image
                                                                                    preview={false}
                                                                                    className="img-fluid"
                                                                                    width={40}
                                                                                    src={'/images/pet-paws.png'} 
                                                                                />
                                                                                <span className="name-text">{upperCase(pp.name)}</span>
                                                                            </div>
                                                                        </Col>
                                                                        <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                                                                            <div className="plan-price">
                                                                                <Fragment>
                                                                                    <sub>{CURRENCY}</sub>
                                                                                    <span className="price-amount">{pp.planVal}</span>
                                                                                </Fragment>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Divider />
                                                                    <div className="breakdown-details mb-4">
                                                                        <Row gutter={15} align="middle">
                                                                            <Fragment>
                                                                                <Col xs={24} sm={11} md={11} lg={11} xl={11}>
                                                                                    <ul className="detail-inner left">
                                                                                        <li>Selected Plan <span>{pp.planName}</span></li>
                                                                                        <li>Deductible <span>{CURRENCY} {pp.deductible == 100 ? 500 : pp.deductible == 250 ? 1000 : 2000}</span></li>
                                                                                        <li>Reimbursement <span>{pp.reimbursement}%</span></li>
                                                                                    </ul>
                                                                                </Col>
                                                                                <Col xs={24} sm={2} md={2} lg={2} xl={2}></Col>
                                                                                <Col xs={24} sm={11} md={11} lg={11} xl={11}>
                                                                                    <ul className="detail-inner right">
                                                                                        <li>Annual Premium <span>{CURRENCY} {pp.planVal}</span></li>
                                                                                        {pp.discount > 0 && (
                                                                                            <li>Discount ({pp.discount * 100}%) <span>{CURRENCY} {pp.discountAmount > 0 ? "-": ""}{pp.discountAmount}</span></li>
                                                                                        )}
                                                                                        <li>Policy Fee <Tooltip title="It is charged only once"><i className="fa fa-question-circle"></i></Tooltip> <span>{CURRENCY} {pp.policyValue}</span></li>
                                                                                        <li>VAT (5%) <span>{CURRENCY} {pp.vat}</span></li>
                                                                                        <li className="text-red">{upperCase(pp.name)}'s Total <span>{CURRENCY} {pp.total}</span></li>
                                                                                    </ul>
                                                                                </Col>
                                                                            </Fragment>
                                                                        </Row>
                                                                    </div>
                                                                </Col>
                                                            ))}
                                                        </Row>
                                                    </div>
                                                    
                                                    {/* Payment Options */}
                                                    {this.state.enableTamara && this.state.tamaraTotal < 20000 && (
                                                        <Row gutter={10}>
                                                            <Col xl={12} lg={12} md={12} sm={12} xs={24} offset={0}>
                                                                <div 
                                                                    className={`section-gray pet-summary price-selector p-4 ${this.state.selectedPaymentMethod === 'mi' ? 'active' : ''}`}
                                                                    onClick={() => this.onPaymentMethodChange('mi')}
                                                                >
                                                                    <Title level={3} className="text-light-green">
                                                                        Pay with <img style={{width:100}} src={tamaralogo} alt="Tamara" />
                                                                    </Title>
                                                                    <Paragraph className="notes">
                                                                        You can pay by four monthly installments
                                                                    </Paragraph>
                                                                    <Title level={4} className="text-light-green">Today's Payment</Title>
                                                                    <div className="plan-price text-center">
                                                                        <Fragment>
                                                                            <sub>{CURRENCY}</sub>
                                                                            <span className="price-amount">
                                                                                {parseFloat(this.state.tamaraInstallmentValue).toFixed(2)}
                                                                            </span>
                                                                        </Fragment>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col xl={12} lg={12} md={12} sm={12} xs={24} offset={0}>
                                                                <div 
                                                                    className={`section-gray pet-summary price-selector p-4 ${this.state.selectedPaymentMethod === 'ot' ? 'active' : ''}`}
                                                                    onClick={() => this.onPaymentMethodChange('ot')}
                                                                >
                                                                    <Title level={3} className="text-light-green">Annual Payment</Title>
                                                                    <Paragraph className="notes">
                                                                        Make one time payment and save <strong>{CURRENCY} {parseFloat(this.state.tamaraTotal - this.state.total).toFixed(2)}</strong>.
                                                                    </Paragraph>
                                                                    <Title level={4} className="text-light-green">Today's Payment</Title>
                                                                    <div className="plan-price text-center">
                                                                        <Fragment>
                                                                            <sub>{CURRENCY}</sub>
                                                                            <span className="price-amount">
                                                                                {parseFloat(this.state.total).toFixed(2)}
                                                                            </span>
                                                                        </Fragment>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    )}
                                                    
                                                    {/* Payment Summary */}
                                                    <div className="total-amount">
                                                        Now You Pay
                                                        <div className="plan-price">
                                                            <Fragment>
                                                                <sub>{CURRENCY}</sub>
                                                                <span className="price-amount">
                                                                    {parseFloat(this.state.selectedPaymentMethod === 'ot' ? 
                                                                        this.state.total : 
                                                                        this.state.tamaraInstallmentValue).toFixed(2)}
                                                                </span>
                                                            </Fragment>
                                                        </div>
                                                    </div>
                                                    
                                                    {/* Action Buttons */}
                                                    <Form.Item className="mt-0">
                                                        <div>
                                                            <div className="steps-action full-width mt-5 text-center">
                                                                <Button size="large" type="primary" className="btn-red rounded-100" htmlType="submit">
                                                                    Purchase
                                                                </Button>
                                                            </div>
                                                            <div className="steps-action full-width mt-2 text-center">
                                                                <Button type="text" size="large" className="mx-2 rounded-100" onClick={() => window.history.back()}>
                                                                    Back to Plans
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </Form.Item>
                                                </Form>
                                            </Spin>
                                        </Col>
                                        
                                        {/* Important Dates */}
                                        <Col xl={8} lg={8} md={24} sm={24} xs={24}>
                                            <div className="important-date mb-5">
                                                <div className="section-heading bg-green mb-3">Important dates</div>
                                                <Card>
                                                    <Carousel autoplay>
                                                    {
                                                        petsWithPlans.map((pp, objIndex) => {
                                                            const { policyEffectiveDate, accidentCoverEffectiveDate, illnessCoverEffectiveDate, kneeCoverEffectiveDate } = pp;
                                                            return (
                                                            <>
                                                                <h3 className="text-light-green pb-3">{upperCase(pp.name)}</h3>
                                                                <ul className="w-100">
                                                                    <li>
                                                                        <Title level={3} className="text-light-green">Policy effective date</Title>
                                                                        <time>{policyEffectiveDate.toLocaleDateString('en-US', {
                                                                            year: 'numeric',
                                                                            month: 'short',
                                                                            day: '2-digit',
                                                                        })}</time>
                                                                    </li>
                                                                    <li>
                                                                        <Title level={3} className="text-light-green">Accident coverage starts</Title>
                                                                        <time>{accidentCoverEffectiveDate.toLocaleDateString('en-US', {
                                                                            year: 'numeric',
                                                                            month: 'short',
                                                                            day: '2-digit',
                                                                        })}</time>
                                                                    </li>
                                                                    <li>
                                                                        <Title level={3} className="text-light-green">Illness coverage starts</Title>
                                                                        <time>{illnessCoverEffectiveDate.toLocaleDateString('en-US', {
                                                                            year: 'numeric',
                                                                            month: 'short',
                                                                            day: '2-digit',
                                                                        })}</time>
                                                                    </li>
                                                                    <li>
                                                                        <Title level={3} className="text-light-green">Knee coverage starts</Title>
                                                                        <time>{kneeCoverEffectiveDate.toLocaleDateString('en-US', {
                                                                            year: 'numeric',
                                                                            month: 'short',
                                                                            day: '2-digit',
                                                                        })}</time>
                                                                    </li>
                                                                </ul>
                                                            </>)
                                                        })
                                                    }
                                                    </Carousel>
                                                    
                                                    <Paragraph className="notes">
                                                        <Image
                                                            preview={false}
                                                            className="img-fluid"
                                                            src="/images/icon-warning-red.png"
                                                        />
                                                        Pre-existing conditions are not covered. For the health of your pet,
                                                        we recommend an annual exam or to have an exam performed shortly after
                                                        purchasing the insurance policy.
                                                    </Paragraph>
                                                </Card>
                                            </div>
                                            <Sidebar />
                                        </Col>
                                    </Row>
                                    
                                    {/* Modals */}
                                    <Modal
                                        className="find-location-modal"
                                        title={<div className="text-dark-green font-600">Set your Location</div>}
                                        visible={this.state.visible}
                                        footer={false}
                                        closable={false}
                                        onCancel={this.handleCancel}
                                    >
                                        <Form
                                            name="basic"
                                            onFinish={this.formSetLocation}
                                            size={"large"}
                                            className="customise-form"
                                            ref={this.addressFormRef}
                                            initialValues={{
                                                appartment: this.state.appartment,
                                                street: this.state.street,
                                                city: this.state.city
                                            }}
                                        >
                                            <Form.Item
                                                name="appartment"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please input appartment/villa no',
                                                    },
                                                ]}
                                            >
                                                <Input placeholder="* Appartment/Villa No " className="mt-4" />
                                            </Form.Item>
                                            <Form.Item
                                                name="street"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please input street no',
                                                    },
                                                ]}
                                            >
                                                <Input placeholder="* Street No" />
                                            </Form.Item>
                                            <Form.Item
                                                name="city"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please input city',
                                                    },
                                                ]}
                                            >
                                                <Input placeholder="* City" />
                                            </Form.Item>

                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                <Form.Item className="mb-0 text-right">
                                                    <Button className="text-muted" type="link" onClick={this.handleCancel}>
                                                        Cancel
                                                    </Button>
                                                    <Button type="primary" htmlType="submit" className="btn-blue btn-150 rounded-100">
                                                        Confirm & Proceed
                                                    </Button>
                                                </Form.Item>
                                            </Col>
                                        </Form>
                                    </Modal>
                                    
                                    <Modal
                                        className="sec-parent-modal"
                                        title={<div className="text-dark-green font-600">Secondary Pet Parent Details</div>}
                                        visible={this.state.visibleSP}
                                        footer={false}
                                        closable={false}
                                        onCancel={this.handleCancelSP}
                                    >
                                        <Form
                                            name="basic"
                                            onFinish={this.formSetSecPetParent}
                                            size={"large"}
                                            className="customise-form"
                                            ref={this.secPetParentFormRef}
                                        >
                                            <Form.Item
                                                name="secParentName"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please input name',
                                                    },
                                                ]}
                                            >
                                                <Input placeholder="* Name " className="mt-4" />
                                            </Form.Item>
                                            <Form.Item
                                                name="secParentAddress"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please input address',
                                                    },
                                                ]}
                                            >
                                                <Input placeholder="* Address" />
                                            </Form.Item>
                                            <Form.Item
                                                name="city"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please input phone no',
                                                    },
                                                ]}
                                            >
                                                <Input placeholder="* Phone No" />
                                            </Form.Item>

                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                <Form.Item className="mb-0 text-right">
                                                    <Button className="text-muted" type="link" onClick={this.handleCancelSP}>
                                                        Cancel
                                                    </Button>
                                                    <Button type="primary" htmlType="submit" className="btn-blue btn-150 rounded-100">
                                                        Confirm & Proceed
                                                    </Button>
                                                </Form.Item>
                                            </Col>
                                        </Form>
                                    </Modal>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </MainLayout>
            </Fragment>
        );
    }
}

export default UserInformation;